// src/components/PWAInstallBanner.tsx
import React, { useState, useEffect } from 'react';
import { usePWA } from '../hooks/usePWA';

export const PWAInstallBanner: React.FC = () => {
    const { isInstallable, install, isInstalled, isStandalone, isChecking } = usePWA();
    const [showBanner, setShowBanner] = useState(false);

    useEffect(() => {
        if (isChecking) return;

        // Скрываем только если реально установлено
        if (isInstalled || isStandalone) {
            setShowBanner(false);
            return;
        }

        // Показываем всегда, если можно установить
        setShowBanner(isInstallable);
    }, [isInstallable, isInstalled, isStandalone, isChecking]);

    const getMessage = () => {
        const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
        return isMobile ? 'Быстрый доступ с главного экрана' : 'Быстрый доступ с рабочего стола';
    };

    const handleInstall = async () => {
        if (!install) {
            alert('📱 Установка временно недоступна. Попробуйте позже.');
            return;
        }

        try {
            const outcome = await install();

            if (outcome === 'accepted') {
                setShowBanner(false);
            }
            // При 'dismissed' — баннер остаётся, пользователь увидит его снова
        } catch (error) {
            console.error('Ошибка установки:', error);
            alert('❌ Не удалось установить приложение');
        }
    };

    const handleClose = () => {
        // Просто скрываем визуально в рамках текущего рендера,
        // но НЕ сохраняем в storage — при перезагрузке баннер появится снова
        setShowBanner(false);
    };

    if (isChecking || !showBanner || isInstalled || isStandalone) {
        return null;
    }

    return (
        <div className="pwa-banner">
            <div className="banner-content">
                <div className="banner-icon">📱</div>
                <div className="banner-text">
                    <strong className="install-banner-title" >Установите приложение</strong>
                    <span>{getMessage()}</span>
                </div>
                <div className="banner-actions">
                    <button className="install-btn" onClick={handleInstall}>
                        ⬇️ <span className="install-text">Установить</span>
                    </button>
                    <button className="close-btn" onClick={handleClose}>
                        ✕
                    </button>
                </div>
            </div>
        </div>
    );
};